import React, { PureComponent, createContext, useContext } from 'react';
import { Modal } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import { FixMe } from '@utils/types';

interface ModalComponentProps extends Partial<ModalProps> {
  content?: FixMe;
}

interface State {
  props: ModalComponentProps;
  open: boolean;
}

interface ModalState {
  open: boolean;
  show: (props: ModalComponentProps) => void;
  close: () => void;
}
const ModalContext = createContext<ModalState>({
  open: false,
  show: () => null,
  close: () => null,
});

export const useModal = () => useContext(ModalContext);

class ModalProvider extends PureComponent<ModalComponentProps, State> {
  constructor(props: ModalComponentProps) {
    super(props);
    this.state = {
      open: false,
      props: {},
    };
  }

  open = (props: ModalComponentProps = {}) => {
    this.setState({
      props,
      open: true,
    });
  };

  close = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const { children } = this.props;

    const { open, props } = this.state;

    const values = {
      open,
      show: this.open,
      close: this.close,
    };
    const { content, ...restProps } = props;
    return (
      <ModalContext.Provider value={values}>
        <>
          <Modal
            closable={false}
            destroyOnClose
            onOk={this.close}
            onCancel={this.close}
            {...restProps}
            visible={open}
          >
            {content}
          </Modal>
          {children}
        </>
      </ModalContext.Provider>
    );
  }
}

export default ModalProvider;
